import React, { useState } from 'react';

import { Button, Flex } from '@raystack/apsara';
import { For } from '@studio/hoc';

import { RetrievalResponse } from '@src/clients/seeker/api';
import { LinkComp } from '@src/components/CoPilot/ResponseLinks/LinkComp/UICompLink';
import { Show } from '@src/hoc';

interface InfoCompProps {
  links: RetrievalResponse[] | [];
}

export const InfoComp: React.FC<InfoCompProps> = ({ links }) => {
  const [isExpanded, setIsExpanded] = useState(false);

  const toggleExpand = () => {
    setIsExpanded(prev => !prev);
  };

  // Determine initial and expanded link lists
  const initialLinks = links.slice(0, 3);
  const remainingLinks = links.slice(3);
  const remainingCount = remainingLinks?.length;

  return (
    <Flex gap='small' align='center' wrap='wrap'>
      <For each={initialLinks}>
        {(link, index) => <LinkComp key={index} link={link} />}
      </For>

      <Show when={remainingLinks.length > 0}>
        <Show when={isExpanded}>
          <For each={remainingLinks}>
            {(link, index) => <LinkComp key={index} link={link} />}
          </For>
        </Show>
        <Button
          size='small'
          variant='ghost'
          color='accent'
          onClick={toggleExpand}
          data-test-id='ExpandCollapseButton'
        >
          <Show when={isExpanded} fallback={`View ${remainingCount} more`}>
            View Less
          </Show>
        </Button>
      </Show>
    </Flex>
  );
};
